import { render, staticRenderFns } from "./RouterSummary.vue?vue&type=template&id=38de051e&scoped=true&"
import script from "./RouterSummary.vue?vue&type=script&lang=js&"
export * from "./RouterSummary.vue?vue&type=script&lang=js&"
import style0 from "./RouterSummary.vue?vue&type=style&index=0&id=38de051e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38de051e",
  null
  
)

export default component.exports